// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"186":"company","697":"news","885":"downloads"}[chunkId] + "." + {"186":"e0055dcc","697":"7a20aa3f","885":"7951bd6e"}[chunkId] + ".js";
};